import { accessRole } from "../../../../helpers/access_role";
import Shimmer from "react-shimmer-effect";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";
import IndexBloc from "../Index/Blocs/IndexBloc";

// var reformatOptions = function (raw) {
//   return raw.map(function (data) {
//     var newObj = {};
//     newObj["label"] = data.current_position_name_new;
//     newObj["value"] = data.special_allowance_summary_rev_uuid;

//     return newObj;
//   });
// };

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];
    newObj["model"] = data;

    return newObj;
  });
};

// var reformatOptions = function (datas) {
//   console.log(datas);
//   return datas.map(function (item) {
//     debugger;
//     var newObj = {};
//     newObj["label"] = item.current_position_name_new;
//     newObj["value"] = item.special_allowance_summary_rev_uuid;
//     newObj["model"] = item;
//     return newObj;
//   });
// };

class IndexView extends Component {
  queryParams = new URLSearchParams(window.location.search);
  createBloc = new CreateBloc();
  indexBloc = new IndexBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      gradeListOption: null,
      positiontype: [
        { label: "Definitif", value: 1 },
        { label: "PLT", value: 2 },
      ],
      positionOption: null,
      selectedGradeBefore: null,
    };
  }

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  // positionList = () => {
  //   this.createBloc.fetchPosition({
  //     revision_uuid: this.queryParams.get("revision_uuid"),
  //     employee_uuid: this.queryParams.get("employee_uuid"),
  //   });
  //   // alert(uuid)
  // };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  // loadData = () => {
  //   this.positionList();
  // };

  componentDidMount() {
    // this.createBloc.fetchGradeList();
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          this.setState({
            detail: result.data?.response?.result,
            loadingDetail: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.gradeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            gradeListOption: reformatOptions(
              result.data?.response?.result,
              "special_level_code",
              "special_level_uuid"
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.positionListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: reformatOptions(
              result.data?.response?.result,
              "current_position_name_new",
              "special_allowance_summary_rev_uuid"
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    debugger;

    this.createBloc.fetchDetail({
      revision_uuid: this.queryParams.get("revision_uuid"),
    });

    this.createBloc.fetchPosition({
      revision_uuid: this.queryParams.get("revision_uuid"),
      employee_uuid: this.queryParams.get("employee_uuid"),
    });

    this.createBloc.fetchGrade();

    // this.loadData();
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.detailChannel?.unsubscribe();
    this.createBloc.gradeListChannel?.unsubscribe();
    this.createBloc.positionListChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody style={{ height: "500px" }}>
                  <div className="float-end">
                    <Link to={`/kepegawaian/mapping_tunjangan_khusus.html`}>
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Revisi Grade Tunsus Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        {this.state.loadingDetail == false &&
                        this.state.detail ? (
                          <>
                            {this.state.detail
                              .special_allowance_summary_rev_employee_full_name !==
                            ""
                              ? this.state.detail
                                  .special_allowance_summary_rev_employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_employee_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <Select
                          name="revision_uuid"
                          errorMessage="Pilih Jabatan"
                          options={this.state.positionOption}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih jabatan"
                          isLoading={!this.state.positionOption?.length}
                          onChange={(v) =>
                            this.setState({
                              selectedRevisisonUuid: v.value,
                              selectedGradeBefore:
                                v.model
                                  .special_allowance_summary_emp_grade_tunsus,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    {this.state.selectedGradeBefore ? (
                      <>
                        <Row className="mb-3">
                          <label
                            htmlFor="mapping_grade_tunsus_employee_uuid"
                            className="col-md-3 col-form-label"
                          >
                            Grade Sebelum
                          </label>
                          <Col md="9">{this.state.selectedGradeBefore}</Col>
                        </Row>
                      </>
                    ) : null}

                    <Row className="mb-3">
                      <label
                        htmlFor="special_allowance_summary_rev_level_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Grade Revisi <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <Select
                          name="special_allowance_summary_rev_level_uuid"
                          placeholder="Pilihan Grade Revisi..."
                          errorMessage="Pilihan Grade Revisi"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          options={this.state.gradeListOption}
                          // options={this.state.positionOption}
                          // optionLabel="special_level_code"
                          // optionValue="special_level_uuid"
                          isLoading={!this.state.gradeListOption?.length}
                          onChange={(v) =>
                            this.setState({
                              selectedGrade: v.value,
                              selectedGradeName: v.label,
                            })
                          }
                        />

                        <AvField
                          name="special_allowance_summary_rev_emp_grade_tunsus"
                          value={this.state.selectedGradeName}
                          type="hidden"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="mapping_grade_tunsus_special_level_uuid"
                        className="col-md-3 col-form-label"
                      >
                        Berlaku Dari <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name={`mapping_grade_tunsus_start_date`}
                          type="date"
                          errorMessage="MasukkanTanggal Mulai Berlaku"
                          validate={{ required: { value: true } }}
                          placeholder="Tanggal Mulai Berlaku"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/mapping_tunjangan_khusus.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
